import axios from 'axios';
import useAgent from '../../hooks/useAgent';
import baseUrl from '../hooks/url';

const url = `${baseUrl}/options`;

export const getTransactionsOptions = (params) => axios.get(url, { params });
export const useGetTransactionsOptions = () => useAgent(getTransactionsOptions);
